<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              class="body-1 font-weight-bold text-capitalize"
              color="white"
              icon
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.deactive"
          @keydown.esc="dialog.deactive = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
            class="pa-2">
            <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
              Non Aktif Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.deactive = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text 
              class="body-1 font-weight-light text-first mt-3">
              <div 
                class="mb-3">
                <div
                  v-if="detail.is_active === 'Aktif'">
                  Apakah Anda yakin menonaktifkan data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> ini? Jika iya silahkan isi lampiran & catatan dibawah ini :
                </div>

                <div
                  v-else>
                  Apakah Anda yakin mengaktifkan data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> ini?
                </div>
              </div>

              <div v-if="detail.is_active === 'Aktif'">
                <div
                  class="body-2 mb-2">
                  Lampiran
                </div>

                <uploadlamp
                  v-model="upload.lamp" 
                  style="height: 300px;">
                  <div 
                    slot="activator"
                    class="cursor-pointer">
                    <v-card 
                      flat
                      height="300"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <div v-if="form_deactive.is_active_url.length < 1">
                        <v-icon v-if="!process.upload_lamp"
                          size="60" 
                          color="grey">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-else
                          indeterminate
                          :color="set_color">
                        </v-progress-circular>
                      </div>

                      <v-img v-else
                        contain
                        height="300"
                        :src="form_deactive.is_active_url" 
                        :alt="form_deactive.is_active_url"
                        class="text-center d-flex align-center">
                        <div 
                          class="d-flex aling-center justify-center" 
                          style="width: 100%; height: auto;">
                          <v-icon v-if="!process.upload_lamp"
                            size="60" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>

                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </div>
                      </v-img>
                    </v-card>
                  </div>
                </uploadlamp>

                <div
                  class="mt-6">
                  <v-textarea
                    outlined
                    dense
                    rows="3"
                    hide-details
                    :color="set_color"
                    placeholder="Contoh. Tulis catatan disini . . ."

                    v-uppercase

                    v-model="form_deactive.is_active_desc">
                  </v-textarea>
                </div>
              </div>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-center">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn
                color="green"
                elevation="0"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                :disabled="process.deactive"
                :loading="process.deactive"
                @click="deactived()">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Ya, {{ detail.is_active === 'Aktif' ? 'Non Aktif' : 'Aktif' }}
              </v-btn>

              <v-btn
                outlined
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize red--text"
                :disabled="process.deactive"
                @click="dialog.deactive = false; dialog.fullscreen = false;">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section
          class="pa-4 pr-1">
          <v-card v-if="process.load && Object.keys(detail).length < 1"
            flat
            color="white"
            min-height="calc(100vh - 95px)"
            style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
            <v-card-text>
              <div
                class="d-flex align-center">
                <div>
                  <v-img
                    contain
                    width="150"
                    height="auto"
                    alt="umb" 
                    :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon.svg')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>

                <v-spacer />

                <div
                  class="black--text text-right">
                  <div
                    class="title font-weight-bold line-text-first">
                    Kadipaten Pakualaman
                  </div>

                  <div
                    class="body-2 font-weight-bold line-text-first">
                    Pura Pakualaman | Purwokinanti, Yogyakarta 55112
                  </div>

                  <div
                    class="body-2 font-weight-bold line-text-first">
                    0274-582152 | kadipatenpakualaman@gmail.com
                  </div>
                </div>
              </div>

              <v-divider
                class="mt-4 mb-1"
                style="border-top: 3px solid black;" />

              <v-divider
                style="border-top: 1px solid black;" />
            </v-card-text>
            
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="2">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="image">
                  </v-skeleton-loader>
                </v-col>

                <v-col
                  cols="12"
                  md="10"
                  class="py-0">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="article, article">
                  </v-skeleton-loader>
                </v-col>
              </v-row>

              <v-skeleton-loader
                class="ma-auto"
                :loading="process.load"
                type="article, article, table">
              </v-skeleton-loader>
            </v-card-text>
          </v-card>

          <v-card v-if="!process.load && Object.keys(detail).length > 0"
            flat
            color="white"
            min-height="calc(100vh - 95px)"
            style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
            <v-card-text>
              <div 
                @click="$router.go(-1)"
                class="d-flex align-center cursor-pointer mb-6"
                style="width: 7%;">
                <v-icon :color="set_color">mdi-arrow-left-thick</v-icon>
            
                <span 
                  class="body-1 ml-1 black--text"
                  style="opacity: 60%;">
                  Kembali
                </span>
              </div>
            </v-card-text>

            <v-card-text>
              <div
                class="d-flex align-center">
                <div>
                  <v-img
                    contain
                    width="150"
                    height="auto"
                    alt="umb" 
                    :src="Object.keys(company).length > 0 ? company.logo : require('@/assets/logo/favicon.svg')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>

                <v-spacer />

                <div
                  class="black--text text-right">
                  <div
                    class="title font-weight-bold line-text-first">
                    Kadipaten Pakualaman
                  </div>

                  <div
                    class="body-2 font-weight-bold line-text-first">
                    Pura Pakualaman | Purwokinanti, Yogyakarta 55112
                  </div>

                  <div
                    class="body-2 font-weight-bold line-text-first">
                    0274-582152 | kadipatenpakualaman@gmail.com
                  </div>
                </div>
              </div>

              <v-divider
                class="mt-4 mb-1"
                style="border-top: 3px solid black;" />

              <v-divider
                style="border-top: 1px solid black;" />
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Biodata Abdi Dalem
              </div>

              <v-divider
                class="mb-4"
                style="border-top: 1px solid black;" />

              <v-row>
                <v-col
                  cols="12"
                  md="2">
                  <v-img
                    contain
                    width="100%"
                    height="auto"
                    alt="umb" 
                    :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member_default.jpg')"
                    class="ma-auto">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-col>

                <v-col
                  cols="12"
                  md="10"
                  class="font-weight-bold black--text pl-6">
                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Nomor Induk Kependudukan
                    </v-col>

                    <v-col
                      cols="6"
                      class="py-0 text-left">
                      : {{ detail.code }}
                    </v-col>

                    <v-col
                      cols="3"
                      class="py-0 text-right">
                      <v-btn
                        :href="detail.nik_url"
                        target="_blank"
                        small
                        elevation="0"
                        :color="set_color"
                        class="text-capitalize white--text"
                        style="border-radius: 10px;">
                        <v-icon small>mdi-eye-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          Lihat
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Nama Lengkap
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : {{ detail.name }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Jenis Kelamin
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : {{ detail.gender }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Kawedanan
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : 
                      <span v-if="detail.kawedanan !== undefined && detail.kawedanan.length > 0">
                        <span
                          v-for="(item, index) in detail.kawedanan"
                          :key="index">
                          {{ item.name }} {{ index < detail.kawedanan.length - 1 ? ',' : '' }}
                        </span>
                      </span>

                      <span v-else>
                        <!-- BELUM DIINPUT -->
                        -
                      </span>
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Urusan
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      :
                      <span v-if="detail.seksi !== undefined && detail.seksi.length > 0">
                        <span
                          v-for="(item, index) in detail.seksi"
                          :key="index">
                          {{ item.name }} {{ index < detail.seksi.length - 1 ? ',' : '' }}
                        </span>
                      </span>

                      <span v-else>
                        <!-- BELUM DIINPUT -->
                        -
                      </span>
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Kategori
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : {{ detail.category }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1" v-if="detail.category === 'SENTANA' ">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Trah
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : {{ detail.trah_name }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1" v-if="detail.category === 'SENTANA' ">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Status Trah
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : {{ detail.trah_status_name }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Status
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : {{ detail.status }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Mulai Aktif
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left text-uppercase">
                      : {{ detail.join_date | date }}
                    </v-col>
                  </v-row>

                  <v-row
                    class="mb-1">
                    <v-col
                      cols="3"
                      class="py-0 text-left">
                      Lama Mengabdi
                    </v-col>

                    <v-col
                      cols="8"
                      class="py-0 text-left">
                      : {{ detail.lama_mengabdi }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Data Personal
              </div>

              <v-divider
                class="mb-4"
                style="border-top: 1px solid black;" />
              
              <div
                class="font-weight-bold black--text">
                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Nomor Kartu Keluarga
                  </v-col>

                  <v-col
                    cols="7"
                    class="py-0 text-left">
                    : {{ detail.kk }}
                  </v-col>

                  <v-col
                    cols="3"
                    class="py-0 text-right">
                    <v-btn
                      :href="detail.kk_url"
                      target="_blank"
                      small
                      elevation="0"
                      :color="set_color"
                      class="text-capitalize white--text"
                      style="border-radius: 10px;">
                      <v-icon small>mdi-eye-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        Lihat
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    NPWP
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.npwp }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Tempat Lahir
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.birthplace }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Tanggal Lahir
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left text-uppercase">
                    : {{ detail.birthdate | date }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Usia
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.age }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Alamat KTP
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.ktp_address }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Alamat Domisili
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.domicile_address }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Agama
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.religion }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Golongan Darah
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.blood_group }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Pendidikan Terakhir
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.last_education }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Gelar Pendidikan
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.degree_education }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Pekerjaan
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.profession }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Status Perkawinan
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.marital_status }}
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Data Kalenggahan
              </div>

              <v-divider
                class="mb-6"
                style="border-top: 1px solid black;" />

              <v-card
                flat
                class="pa-1"
                style="border: 1px solid black;">
                <v-simple-table
                  fixed-header>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Kalenggahan
                        </th>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Nama Kalenggahan
                        </th>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Nomor SK
                        </th>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Tanggal
                        </th>
                        <th class="text-center body-2 black--text font-weight-bold">
                          Lampiran
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in list.kalenggahan"
                        :key="index">
                        <td class="text-left black--text font-weight-bold">{{ item.title }}</td>
                        <td class="text-left black--text font-weight-bold">{{ item.name }}</td>
                        <td class="text-left black--text font-weight-bold">{{ item.no_sk }}</td>
                        <td class="text-left black--text font-weight-bold text-uppercase">{{ item.date | date }}</td>
                        <td class="text-center black--text font-weight-bold">
                          <v-btn
                            :href="item.url"
                            target="_blank"
                            small
                            elevation="0"
                            :color="set_color"
                            class="text-capitalize white--text"
                            style="border-radius: 10px;">
                            <v-icon small>mdi-eye-circle-outline</v-icon>
                            
                            <span
                              class="ml-1">
                              Lihat
                            </span>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
              
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Data Urusan
              </div>

              <v-divider
                class="mb-4"
                style="border-top: 1px solid black;" />
              
              <v-card
                flat
                class="pa-1"
                style="border: 1px solid black;">
                <v-simple-table
                  fixed-header>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Jabatan
                        </th>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Nomor SK
                        </th>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Tanggal
                        </th>
                        <th class="text-left body-2 black--text font-weight-bold">
                          Urusan
                        </th>
                        <th class="text-center body-2 black--text font-weight-bold">
                          Lampiran
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in list.urusan"
                        :key="index">
                        <td class="text-left black--text font-weight-bold">{{ item.title }}</td>
                        <td class="text-left black--text font-weight-bold">{{ item.no_sk }}</td>
                        <td class="text-left black--text font-weight-bold text-uppercase">{{ item.date | date }}</td>
                        <td class="text-left black--text font-weight-bold">{{ item.desc }}</td>
                        <td class="text-center black--text font-weight-bold">
                          <v-btn
                            :href="item.url"
                            target="_blank"
                            small
                            elevation="0"
                            :color="set_color"
                            class="text-capitalize white--text"
                            style="border-radius: 10px;">
                            <v-icon small>mdi-eye-circle-outline</v-icon>
                            
                            <span
                              class="ml-1">
                              Lihat
                            </span>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Data Kontak
              </div>

              <v-divider
                class="mb-4"
                style="border-top: 1px solid black;" />
              
              <div
                class="font-weight-bold black--text">
                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Nomor Telepon
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.mobilephone }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Nomor Whatsapp
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.wa_number }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Nomor Kontak Darurat
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.emergency_number }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Nama (Nomor Kontak Darurat)
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.emergency_number_name }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Email
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.email }}
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Data Keluarga
              </div>

              <v-divider
                class="mb-4"
                style="border-top: 1px solid black;" />

              <div
                v-for="(item, index) in list.keluarga"
                :key="index"
                :class="index < list.keluarga.length - 1 ? 'mb-8' : ''"
                class="font-weight-bold black--text">
                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Nama Lengkap
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ item.name }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Nama Kalenggahan
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ item.kalenggahan_name }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Hubungan
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ item.relation }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Jenis Kelamin
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ item.gender }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Tempat Lahir
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left text-uppercase">
                    : {{ item.birthplace }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Tanggal Lahir
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left text-uppercase">
                    : {{ item.birthdate | date }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Pekerjaan
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ item.job }}
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Data Pakaian
              </div>

              <v-divider
                class="mb-4"
                style="border-top: 1px solid black;" />
              
              <div
                class="font-weight-bold black--text">
                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Ukuran Kaos
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.ukuran_kaos }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Ukuran Blangkon
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.ukuran_blangkon }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Ukuran Selop
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.ukuran_selop }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Ukuran Pranakan
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.ukuran_pranakan }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="2"
                    class="py-0 text-left">
                    Ukuran Atela
                  </v-col>

                  <v-col
                    cols="10"
                    class="py-0 text-left">
                    : {{ detail.ukuran_atela }}
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <v-card-text
              class="text-center px-8">
              <v-divider
                style="border-top: 1px solid black;" />

              <div
                class="body-1 font-weight-bold black--text my-1">
                Data Lain-lain
              </div>

              <v-divider
                class="mb-4"
                style="border-top: 1px solid black;" />
              
              <div
                class="font-weight-bold black--text">
                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Nomor Rekening Danais
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left">
                    : {{ detail.norek_danais }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Tanggal Awal Terima Danais
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left text-uppercase">
                    : {{ detail.tgl_awal_terima_danais | date }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Tanggal Gabung Koprasi
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left text-uppercase">
                    : {{ detail.kop_join_date | date }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Jenis BPJS
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left">
                    : {{ detail.bpjs_jenis }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Memiliki Asuransi Kesehatan dan/atau Ketenagakerjaan
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left">
                    : {{ detail.asuransi_kes }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Nomor Polis Asuransi
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left">
                    : {{ detail.nomor_polis_asuransi }}
                  </v-col>
                </v-row>

                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Status Asuransi
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left">
                    : {{ detail.asuransi_status }}
                  </v-col>
                </v-row>

                <v-divider
                  class="mt-8 mb-4"
                  style="border-top: 1px solid black;" />

                <v-row
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Status Abdi Dalem
                  </v-col>

                  <v-col
                    cols="9"
                    class="py-0 text-left">
                    : {{ detail.is_active }}
                  </v-col>
                </v-row>

                <v-row v-if="detail.is_active !== 'Aktif'"
                  class="mb-1">
                  <v-col
                    cols="3"
                    class="py-0 text-left">
                    Alasan Non Aktif
                  </v-col>

                  <v-col
                    cols="6"
                    class="py-0 text-left">
                    : {{ detail.is_active_desc }}
                  </v-col>

                  <v-col
                    cols="3"
                    class="py-0 text-right">
                    <v-btn
                      :href="detail.is_active_url"
                      target="_blank"
                      small
                      elevation="0"
                      :color="set_color"
                      class="text-capitalize white--text"
                      style="border-radius: 10px;">
                      <v-icon small>mdi-eye-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        Lihat
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>

                <div v-if="user.role !== 'viewer'"
                  class="text-left font-weight-light"
                  style="opacity: 60%;">
                  Ubah <span class="font-italic">"klik tombol dibawah"</span>.
                </div>

                <v-divider
                  class="mt-4"
                  style="border-top: 1px solid black;" />
              </div>
            </v-card-text>

            <v-card-actions
              class="px-8 pb-4">
              <v-btn  v-if="hak_akses.action.aktif"
                @click="toDeactive()"
                :color="detail.is_active === 'Aktif' ? 'orange' : '#00bcd4'"
                elevation="0"
                class="body-2 font-weight-bold white--text text-capitalize"
                style="border-radius: 10px;">
                <v-icon small class="mr-1">
                  {{
                    detail.is_active === 'Aktif' ? 'mdi-swap-horizontal-circle-outline' : 'mdi-check-circle-outline'
                  }}
                </v-icon>

                {{
                  detail.is_active === 'Aktif' ? 'Non Aktif' : 'Aktif'
                }}
              </v-btn>
              
              <v-spacer/>
              
              <v-btn v-if="hak_akses.action.update"
                :to="`/sentana/form/edit/${detail.id}?step=1`"
                :disabled="process.print"
                :color="set_color"
                outlined
                elevation="0"
                class="body-2 font-weight-bold text-capitalize"
                :style="`color: ${set_color};`"
                style="border-radius: 10px;">
                <v-icon small class="mr-1">mdi-circle-edit-outline</v-icon>

                Ubah
              </v-btn>

              <v-btn 
                @click="prints()"
                :disabled="process.print"
                :loading="process.print"
                :color="set_color"
                elevation="0"
                class="body-2 font-weight-bold white--text text-capitalize"
                style="border-radius: 10px;">
                <v-icon small class="mr-1">mdi-microsoft-excel</v-icon>

                Print
              </v-btn>
            </v-card-actions>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false,
          deactive: false
        },
        detail: {},
        list: {
          kalenggahan: [],
          urusan: [],
          keluarga: []
        },

        upload: {
          lamp: null
        },
        form_deactive: {
          id: '',
          is_active_desc: '',
          is_active_url: ''
        },

        process: {
          load: false,
          print: false,

          upload_lamp: false,
          deactive: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadlamp: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.lamp': {
        handler: function () {
          if (this.upload.lamp) {
            this.process.upload_lamp = this.upload.lamp.process

            if (!this.process.upload_lamp) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form_deactive.is_active_url = this.upload.lamp.fileuri
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 4) {
            menu = item
          }
        })
        return menu
      },
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.detail = res.results.data

            this.fetchKalenggahan()
            this.fetchUrusan()
            this.fetchKeluarga()
          }
        })
      },

      async fetchKalenggahan () {
        let params = {
          user_id: this.$route.params.id
        }

        await get('admin/user_kalenggahan', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list.kalenggahan = res.results.data
          }
        })
      },

      async fetchUrusan () {
        let params = {
          user_id: this.$route.params.id
        }

        await get('admin/user_urusan', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list.urusan = res.results.data
          }
        })
      },

      async fetchKeluarga () {
        let params = {
          user_id: this.$route.params.id
        }

        await get('admin/user_family', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list.keluarga = res.results.data
          }
        })
      },

      // PRINT
      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          id: this.$route.params.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/user/export_individu`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            // console.log(response.headers['Content-Disposition'])
            
            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },

      // NON AKTIF
      toDeactive () {
        this.form_deactive = {
          id: this.$route.params.id,
          is_active_desc: '',
          is_active_url: ''
        }

        this.dialog.deactive = true
      },
      async deactived () {
        this.message.error = ''

        this.process.deactive = true

        let url = this.detail.is_active === 'Aktif' ? 'admin/user/deactivate' : 'admin/user/activate'
        
        await post(url, {
          data: this.form_deactive
        })
        .then((response) => {
          let res = response.data

          if (res.status === 200) {
            this.process.deactive = false

            this.dialog.deactive = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          } else {
            this.process.deactive = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>